export default "__VITE_ASSET__DF7y904o__"